module.exports = __webpack_public_path__ + "static/media/onTheBall.30e13ed8.png";